.containerAndDragHandle {
  &.success {
    background: var(--sentiment-background-positive);
  }
}

.packingGroupItemContainer {
  padding: 1rem;
}
.containerAndDragHandle:not(:last-child) {
  border-bottom: 1px dashed var(--static-divider-standard);
}

.productStatusItem {
  align-items: center;
  height: fit-content;
  white-space: nowrap;
  padding: 1px 10px;
  border-radius: 6px;

  &.success {
    color: var(--sentiment-text-positive);
    background: var(--sentiment-background-positive);
  }
  &.warn {
    color: var(--sentiment-text-notice);
    background: var(--sentiment-background-notice);
  }
}

.buttonStyles {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.actionButtonContent {
  white-space: nowrap;
  gap: 4px;
  min-width: max-content;
}

.bottomRow {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  padding: 18px 0 6px;
  justify-content: flex-end;
  font-size: var(--fs-small);
}

.quantityInput {
  width: 102px;
}

.quantityToAssign {
  font-weight: var(--font-weight-strong);
}

.prepInstructionsContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: var(--sentiment-text-neutral);
  white-space: nowrap;
  align-self: stretch;
  flex-wrap: wrap;
  & > span {
    min-width: 0;
    flex: 0;
    flex-basis: content;
    overflow: hidden;
    text-overflow: ellipsis;
    background: var(--sentiment-background-neutral);
    padding: 1px 0;
  }
  & > span:last-child {
    padding-right: 6px;
    border-radius: 0 6px 6px 0;
  }
  & .prepInstructions {
    display: flex;
    align-items: center;
    min-width: fit-content;
    padding-right: 5px;
    padding-left: 6px;
    border-radius: 6px 0 0 6px;
    cursor: help;
  }
}
.prepInstruction {
  white-space: nowrap;
}